import React from "react";
import {
  Bolt,
  WaterDrop,
  GasMeter,
  Sensors,
  DeviceHub,
} from "@mui/icons-material";

/**
 * Component that returns the appropriate icon for a device type
 *
 * @param {Object} props Component properties
 * @param {string} props.deviceType The device type name or identifier
 * @param {string} props.color The color for the icon
 * @param {number} props.size The size of the icon
 * @param {number} props.deviceBrandId The device brand ID for specific AM103 detection
 * @returns {JSX.Element} The icon component
 */
const DeviceTypeIcon = ({ deviceType, color, size = 80, deviceBrandId }) => {
  const typeName = (deviceType || "").toLowerCase();
  
  // AM103 specific icons based on device_brand_id (emojis pour cohérence)
  if (deviceBrandId === 37) {
    // AM103 Temperature ambiante
    return <span style={{ fontSize: size }}>🌡️</span>;
  } else if (deviceBrandId === 38) {
    // AM103 Humidity
    return <span style={{ fontSize: size }}>💧</span>;
  } else if (deviceBrandId === 39) {
    // AM103 CO2
    return <span style={{ fontSize: size }}>🌬️</span>;
  }
  
  // Original logic for other device types
  if (typeName.includes("water")) {
    return <WaterDrop sx={{ fontSize: size, color: "#4fc3f7" }} />;
  } else if (
    typeName.includes("electric") ||
    typeName.includes("electricity")
  ) {
    return <Bolt sx={{ fontSize: size, color: "#ffd54f" }} />;
  } else if (typeName.includes("gas")) {
    return <GasMeter sx={{ fontSize: size, color }} />;
  } else if (typeName.includes("temp") || typeName.includes("temperature")) {
    // Flocon pour chambres froides et températures standard (AM103 détecté via deviceBrandId)
    return <span style={{ fontSize: size, color: "#99DDFF" }}>❄️</span>;
  } else if (typeName.includes("sensor")) {
    return <Sensors sx={{ fontSize: size, color }} />;
  } else {
    // Default icon for other types
    return <DeviceHub sx={{ fontSize: size, color }} />;
  }
};

export default DeviceTypeIcon;
